import ProviderTrainings from '../../components/trainings/ProviderTrainings';
import TrainingVideoEmbed from '../../components/trainings/TrainingVideoEmbed';
import TrainingModals from '../../components/trainings/Modals';
import { createStore } from '../../components/trainings/store/store';
import { createApp } from 'vue';

const store = createStore();

if (document.getElementById('provider-trainings')) {

    const app = createApp({
      components: {
        ProviderTrainings,
        TrainingVideoEmbed,
        TrainingModals
      }
    });

    app.use(store);
    app.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app.mount('#provider-trainings');
}


if (document.getElementById('training-modals')) {
    // const store = createStore();
    
    const app2 = createApp({
        components: {
            TrainingModals
        }
    });
    
    app2.use(store);
    app2.config.globalProperties.$basePath = process.env.MIX_APP_URL;
    app2.mount('#training-modals');
}


